import React, { useState, useEffect } from 'react';
import { Card, CardBody, Row, Col } from 'reactstrap';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import CouponVerification from '../components/coupons/CouponVerification';
import CouponRedemptionsList from '../components/coupons/CouponRedemptionsList';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CouponRedemptions = ({ onLogout }) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';
  const [refreshKey, setRefreshKey] = useState(0);
  const [stats, setStats] = useState({ total: 0, redeemed: 0, verified: 0, pending: 0 });
  const [statsLoading, setStatsLoading] = useState(true);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${API_BASE_URL}/api/coupon/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (err) {
      console.error('Failed to fetch stats:', err);
    } finally {
      setStatsLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, [refreshKey]);

  const handleVerificationSuccess = () => {
    setRefreshKey(prev => prev + 1);
    toast.success('Coupon verified successfully');
  };

  const StatCard = ({ title, value, color, icon }) => (
    <Card className="shadow-sm border-0 h-100">
      <CardBody className="d-flex align-items-center">
        <div 
          className="rounded-circle d-flex align-items-center justify-content-center me-3"
          style={{ 
            width: '50px', 
            height: '50px', 
            backgroundColor: `${color}20`,
            color: color
          }}
        >
          <span style={{ fontSize: '1.5rem' }}>{icon}</span>
        </div>
        <div>
          <h3 className="mb-0" style={{ color }}>
            {statsLoading ? '...' : value}
          </h3>
          <small className="text-muted">{title}</small>
        </div>
      </CardBody>
    </Card>
  );

  return (
    <div className='d-flex w-100 overflow-hidden'>
      <div className='asidebar'>
        <Sidebar />
      </div>
      <div className='main-content'>
        <div className='d-flex align-items-center justify-content-between mb-4'>
          <div>
            <h2>Coupon Redemptions</h2>
            <p className="text-muted mb-0">Verify coupon codes and manage redemptions</p>
          </div>
        </div>

        {/* Stats Cards */}
        <Row className="mb-4">
          <Col md={4} sm={6} className="mb-3 mb-md-0">
            <StatCard title="Total Redeemed" value={stats.total} color="#6f42c1" icon="🎟️" />
          </Col>
          <Col md={4} sm={6} className="mb-3 mb-md-0">
            <StatCard title="Verified" value={stats.verified} color="#28a745" icon="✓" />
          </Col>
          <Col md={4} sm={6}>
            <StatCard title="Pending" value={stats.redeemed} color="#ffc107" icon="⏳" />
          </Col>
        </Row>

        {/* Cashier Verification Section */}
        <div className="mb-4">
          <CouponVerification onVerificationSuccess={handleVerificationSuccess} />
        </div>

        {/* Redemptions List */}
        <CouponRedemptionsList key={refreshKey} />

        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      </div>
    </div>
  );
};

export default CouponRedemptions;
